export default "__VITE_ASSET__7dc5c7ef__"